<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-input v-model="query.name" style="width: 150px;" placeholder="系统名称" clearable class="handle-input mr10"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="clickSearch">搜索</el-button>
				<el-button type="primary" @click="showAdd(0)">添加</el-button>
			</div>
			<el-table :data="tableData" border>
				<el-table-column prop="id" label="系统id"></el-table-column>
				<el-table-column prop="name" label="系统名称"></el-table-column>
				<el-table-column prop="accesskey" label="accesskey"></el-table-column>
				<el-table-column prop="secret" label="secret"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button title="修改" plain @click="showAdd(1,scope.row)">修改</el-button>
						<el-button title="删除" plain @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex" :page-size="query.pageRows"
				 :total="total" @current-change="handlePageChange" prev-click="pageChange(1)" next-click="pageChange(2)"></el-pagination>
			</div>

		</div>

		<el-dialog :title="editType==1?'新增':'修改'" :visible.sync="showEdit" width="30%" :show-close="true" :close-on-click-modal="false">

			<el-form :model="obj">

				<el-form-item label="系统名称">
					<el-input type="text" v-model="obj.name" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="accesskey">
					<el-input type="text" v-model="obj.accesskey" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="secret">
					<el-input type="text" v-model="obj.secret" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="showEdit = false">取 消</el-button>
				<el-button type="primary" @click="post">提交</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data: function() {
			return {
				query: {
					name: '',
					pageIndex: 1,
					pageRows: 10
				},
				tableData: [],
				total: 0,
				showEdit: false,
				editType: 0, //0添加 1修改
				obj: {

				},
			}
		},

		created() {
			this.handleSearch()
		},
		methods: {
			clickSearch: function() {
				this.query.pageIndex = 1;
				this.handleSearch();
			},
			handleSearch: function() {
				//查询

				this.HTTP.post('/system/namespace/queryPage', this.query).then(res => {

					if (res.data.code == 1) {
						this.tableData = res.data.rows
						this.total = res.data.counts
					}else{
						this.$message.error(res.data.message);
					}

				}).catch(err => {
					console.log(err)
				})
			},
			handlePageChange: function(e) {
				this.query.pageIndex = e
				this.handleSearch()
			},
			pageChange: function(type) {
				if (type == 1) {
					this.query.pageIndex -= 1;
				} else {
					this.query.pageIndex += 1;
				}

				this.handleSearch()
			},
			showAdd: function(type,data) {
				debugger
				this.editType = type;
				this.showEdit = true
				if (type==0){
					this.obj = {};
				}
				if (type==1){
					this.obj = data;
				}
			},
			del:function(data){
				this.$confirm('请确认是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let param = {
						id:data.id,
						isValid:false
					}
					this.HTTP.post('/system/namespace/addOrUpdate', param)
							.then(res => {
								if (res.data.code == 1) {
									this.handleSearch()
									this.$message.success("删除成功");
								} else {
									this.$message.error(res.data.message);
								}
							})
							.catch(err => {})
				})


			},
			post: function() {
				if (!this.obj.name){
					this.$message.error("名称不能为空");
					return
				}
				this.HTTP.post('/system/namespace/addOrUpdate', this.obj)
					.then(res => {
						if (res.data.code == 1) {
							this.showEdit = false
							this.handleSearch()
						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(err => {})
			},

		}
	}
</script>

<style>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.info-div {
		display: flex;
		justify-content: space-around;
		margin-top: 5px;
		font-size: 13px;
	}

	.info-span1 {
		width: 230px;
		font-size: 15px;
	}

	.info-span2 {
		width: 230px;
		font-size: 15px;
	}

	.info-title {
		margin-right: 4px;
		color: #000000;
	}
</style>
